<template>
  <AppModal :active="active" :header="true" title="Sanction check" icon="checkmark-circle" @close="modalCloseDocumentSanctionCheck()">
    <div class="ModalSanctionCheck_container">
      <div class="ModalSanctionCheck_text">
        <div>
          <b>Stay Compliant with Ease!</b><br />
          Verify quickly whether your business partners or contract parties are on any international sanction lists with our comprehensive checking tool. Access over 100+ sanction lists from around the world in just one click. For full details on which lists we cover, [TODO: click here].<br />
          <br />
          <b>Affordable and Fast</b><br />
          Each search only costs €0.99.<br />
        </div>
      </div>
      <div class="ModalSanctionCheck_button">
        <AppButton @click="getSanctions()" :icon="false" size="medium">Check</AppButton>
      </div>
      <div v-for="(searchResults) in results" :key="searchResults">
        <div class="search-result" v-for="(result) in searchResults" :key="result">
          <div v-for="(item, name) in result" :key="item">
            <div v-if="Array.isArray(item)">{{ name }}: {{ item.join(", ") }}</div>
            <div v-else>{{ name }}: {{ item }}</div>
          </div>
        </div>
      </div>
    </div>
  </AppModal>
</template>

<script>
import AppModal from "@/components/AppModal";
import AppButton from "@/components/AppButton";
import { modalCloseDocumentSanctionCheck } from "@/modals/index";
import { useToast } from "vue-toastification";
import events from "@/events";
import DocumentsService from "@/services/documents";
import { checkErrors } from "@/utilities/errors";

export default {
  name: "ModalSanctionCheck",
  components: {
    AppModal,
    AppButton
  },
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    active(value) {
      if (value) {
        this.getSanctions();
      }
    }
  },
  data() {
    return {
      results: []
    }
  },
  setup() {
    const toast = useToast();

    return {
      modalCloseDocumentSanctionCheck,
      toast,
      events
    };
  },
  methods: {
    getSanctions() {
      const Documents = new DocumentsService(process.env.VUE_APP_API_URL, process.env.VUE_APP_API_ID);

      Documents.getDMonitor("", "").then((data) => {
        if (data.status === "OK") {
          this.results = data.results;
        }
      }).catch((error) => {
        checkErrors(error);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.ModalSanctionCheck_container {
  display: flex;
  flex-direction: column;
  width: 100%;

  .ModalSanctionCheck_text {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    font-size: 14px;
    line-height: 1.5;
    color: #4a4a4a;
    margin-bottom: 20px;
  }

  .ModalSanctionCheck_button {
    margin-left: auto;
  }
}
.search-result {
  font-size: 0.75rem;
  margin-bottom: 1.0rem;
}
</style>
